import { createApi } from '@reduxjs/toolkit/query/react'
import { MDT_ASSESSMENT_DATE_CREATE, MDT_ASSESSMENT_DATE_DELETE, MDT_ASSESSMENT_DATE_UPDATE, MDT_ASSESSMENT_LIST, MDT_ASSESSMENT_STATUS_UPDATE, MDT_ASSESSMENT_UPDATE, MDT_ASSESSMENT_VIEW, MDT_ASSIGN_CHECKLIST, MDT_CHECKLIST_UPDATE } from "config/apiPaths"
import { RTK_CACHE_EXPIRATION } from "config/constants";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const mdtAssessmentApi = createApi({
    reducerPath: 'mdtAssessmentApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/mdt",
    }),
    tagTypes: ["mdtAssessmentList", "mdtAssessmentDetails"],
    keepUnusedDataFor: RTK_CACHE_EXPIRATION,
    endpoints: (builder) => ({

        // get mdt assessment list
        getMdtAssessmentList: builder.query({
            query: ({ search = "", client_type = "", status = "", specialization = "", mdtStatus = "", startDate = "", endDate = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: MDT_ASSESSMENT_LIST,
                data: { search, status, client_type: client_type?.value || "", specialization: specialization?.value || "", mdtStatus: mdtStatus?.value || "", startDate, endDate, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtAssessmentList"]
        }),

        // update assessment status
        updateAssesmentStatus: builder.mutation({
            query: ({ caseLoadId, statusId }) => ({
                method: "PUT",
                url: `${MDT_ASSESSMENT_STATUS_UPDATE}/${caseLoadId}/${statusId}`
            }),
            invalidatesTags: ["mdtAssessmentList", "mdtAssessmentDetails"]
        }),

        // create assessment
        getMdtAssessmentDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MDT_ASSESSMENT_VIEW}/${id}`

            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtAssessmentDetails"]
        }),

        // assessment check list status
        assignCheckList: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MDT_ASSIGN_CHECKLIST,
                data
            }),
            invalidatesTags: ["mdtAssessmentDetails"]
        }),

        // update assessment details
        updateAssesment: builder.mutation({
            query: ({ assessmentId, data }) => ({
                method: "PUT",
                url: `${MDT_ASSESSMENT_UPDATE}/${assessmentId}`,
                data
            }),
            invalidatesTags: ["mdtAssessmentList", "mdtAssessmentDetails"]
        }),

        // add an assessment date for an assigned clinician
        createAssessmentDate: builder.mutation({
            query: ({ caseload_therapist_id, assessment_date, assessment_time }) => ({
                method: "POST",
                url: `${MDT_ASSESSMENT_DATE_CREATE}/${caseload_therapist_id}`,
                data: { assessment_date, assessment_time }
            }),
            invalidatesTags: ["mdtAssessmentList", "mdtAssessmentDetails"]
        }),

        // update an assigned clinician assessment date
        updateAssessmentDate: builder.mutation({
            query: ({ assessment_date_id, assessment_date, assessment_time }) => ({
                method: "PUT",
                url: `${MDT_ASSESSMENT_DATE_UPDATE}/${assessment_date_id}`,
                data: { assessment_date, assessment_time }
            }),
            invalidatesTags: ["mdtAssessmentList", "mdtAssessmentDetails"]
        }),

        // delete an assigned clinician assessment date
        deleteAssessmentDate: builder.mutation({
            query: ({ assessment_date_id }) => ({
                method: "DELETE",
                url: `${MDT_ASSESSMENT_DATE_DELETE}/${assessment_date_id}`,
            }),
            invalidatesTags: ["mdtAssessmentList", "mdtAssessmentDetails"]
        }),

        // update checklist status
        updateCheckListStatus: builder.mutation({
            query: ({ id, status, caseload_id }) => ({
                method: "PUT",
                url: `${MDT_CHECKLIST_UPDATE}/${caseload_id}/${id}/${status}`,
            }),
            invalidatesTags: ["mdtAssessmentDetails"]
        }),
    }),
})

export const {
    useGetMdtAssessmentListQuery,
    useUpdateAssesmentStatusMutation,
    useGetMdtAssessmentDetailsQuery,
    useAssignCheckListMutation,
    useUpdateAssesmentMutation,
    useCreateAssessmentDateMutation,
    useUpdateAssessmentDateMutation,
    useDeleteAssessmentDateMutation,
    useUpdateCheckListStatusMutation

} = mdtAssessmentApi;
